import { defineStore } from 'pinia'
import { ref } from 'vue'

export type NavPayload = {
  path: string
  data?: Record<string, any>
}

export const useNavStore = defineStore('nav', () => {
  const previous = ref<NavPayload | null>(null)
  const lastUpdated = ref<number | null>(null)

  const sharedBetPath = ref<string | null>(null)
  const sharedBetOriginalQuery = ref<string | null>(null)
  const sharedBetOriginalStructure = ref<string | null>(null)
  const isSharedBetDirty = ref<boolean>(false)
  const isShareModalVisible = ref<boolean>(false)

  function setPrevious(path: string, data?: Record<string, any>) {
    previous.value = { path, data }
    lastUpdated.value = Date.now()
  }

  function setSharedBet(path: string, query: string, structure: string) {
    sharedBetPath.value = path
    sharedBetOriginalQuery.value = query
    sharedBetOriginalStructure.value = structure
    isSharedBetDirty.value = false
  }

  function setIsSharedBetDirty(isDirty: boolean) {
    isSharedBetDirty.value = isDirty
  }

  function setIsShareModalVisible(visible: boolean) {
    isShareModalVisible.value = visible
  }

  function clearSharedBet() {
    sharedBetPath.value = null
    sharedBetOriginalQuery.value = null
    sharedBetOriginalStructure.value = null
    isSharedBetDirty.value = false
    isShareModalVisible.value = false
  }

  function peekPrevious(): NavPayload | null {
    return previous.value
  }

  function consumePrevious(): NavPayload | null {
    const val = previous.value
    previous.value = null
    return val
  }

  function clearPrevious(): void {
    previous.value = null
  }

  return {
    previous,
    lastUpdated,
    sharedBetPath,
    sharedBetOriginalQuery,
    sharedBetOriginalStructure,
    isSharedBetDirty,
    isShareModalVisible,
    setPrevious,
    setSharedBet,
    setIsSharedBetDirty,
    setIsShareModalVisible,
    clearSharedBet,
    peekPrevious,
    consumePrevious,
    clearPrevious,
  }
})
